/**
 * List of uncompatible styles from the editor V2 that
 * are not supported in the legacy configuration.
 */
export const LEGACY_TEXT_OVERLAY_STYLE_BLACKLIST: string[] = [
  '-webkit-text-stroke',
  'text-transform',
];
